import React, { Component } from "react";
import "./MAMCACriteria.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Popconfirm, Table, Empty, Spin, Switch,
    Modal, Button, Form, Input, Tabs, Popover,
    Select, Icon, Tooltip, Steps, Row, Col,
    Upload, Typography, Alert
} from 'antd';
import { Link } from "react-router-dom";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const { Text } = Typography;

const TabPane = Tabs.TabPane;

//create criteria modal
const CreateForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const Option = Select.Option;
            const { TextArea } = Input;
            const {
                visible, onCancel, onCreate, form, criteriaGroup
            } = this.props; //read all the property send from criteria


            //print all the criteria group of this MCA
            const children = [];
            for (let i in criteriaGroup) {
                children.push(<Option key={criteriaGroup[i]}>{criteriaGroup[i]}</Option>);
            }

            const { getFieldDecorator } = form; //can get the input value
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Create a new criterion"
                    okText="Create"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Alert message="Kindly refrain from including periods (.) in the name field." type="info" showIcon />


                    <Form layout="vertical">
                        <Form.Item label="Criterion name">
                            {getFieldDecorator('criteriaName', {
                                rules: [
                                    { required: true, message: 'Please input the name of criterion!' }
                                ], //set the rule
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Criterion description">
                            {getFieldDecorator('criteriaDescription')(
                                <TextArea placeholder="Criterion description" autosize />
                            )}
                        </Form.Item>
                        <Form.Item label="Criterion Indicator">
                            {getFieldDecorator('criteriaIndicator', {
                                // rules: [
                                //     { required: true, message: 'Please input the indicator!' }
                                // ], //set the rule
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Create as a sub-criterion">
                            {getFieldDecorator('switch', { valuePropName: 'checked' })(
                                <Switch />
                            )}
                        </Form.Item>
                        {this.props.form.getFieldsValue().switch === true ?
                            <Form.Item
                                label={(
                                    <span>
                                        Parent criterion &nbsp;
                                        <Tooltip title="The sub-criterion must belong to one criteria">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('criteriaGroup', {
                                    rules: [{ required: true, message: 'Please input the parent criterion!', whitespace: true }],
                                })(
                                    <Select>
                                        {children}
                                    </Select>
                                )}
                            </Form.Item> :
                            <div></div>}
                    </Form>
                </Modal>
            );
        }
    }
);


//edit criteria modal
let EditForm = Form.create({ name: 'edit_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, form, eCriteria//get all the props from criteria
            } = this.props;
            const { TextArea } = Input;

            //print all the criteria group of this MCA
            // const children = [];
            // for (let i in criteriaGroup) {
            //     children.push(<Option key={criteriaGroup[i]}>{criteriaGroup[i]}</Option>);
            // }
            const { getFieldDecorator } = form;
            return (
                <Modal
                    visible={visible}
                    title={"Edit Criterion " + eCriteria.criteriaName} //the name is different per modal
                    okText="Edit"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Alert message="Kindly refrain from including periods (.) in the name field." type="info" showIcon />


                    <Form layout="vertical">
                        <Form.Item label="Criterion name">
                            {getFieldDecorator('criteriaName', {
                                rules: [{ required: true, message: 'Please input the name of criterion!' }],
                                initialValue: eCriteria.criteriaName //get the oringinal criterion name
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Criterion Indicator">
                            {getFieldDecorator('criteriaIndicator', {
                                // rules: [{ required: true, message: 'Please input the indicator!' }],
                                initialValue: eCriteria.criteriaIndicator //get the oringinal criterion name
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Criterion description">
                            {getFieldDecorator('criteriaDescription', {
                                // rules: [{ required: true, message: 'Please input the indicator!' }],
                                initialValue: eCriteria.criteriaDescription //get the oringinal criterion name
                            })(
                                <TextArea autosize />
                            )}
                        </Form.Item>
                        {/* {eCriteria.cid ?
                            <Form.Item
                                label={(
                                    <span>
                                        Parent criterion &nbsp;
                            <Tooltip title="The sub-criterion must belong to one criteria">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('criteriaGroup', {
                                    rules: [{ required: true, message: 'Please input the parent criterion!', whitespace: true }],
                                    initialValue: eCriteria.pCiteriaName
                                })(
                                    <Select>
                                        {children}
                                    </Select>
                                )}
                            </Form.Item> :
                            <div></div>} */}
                    </Form>
                </Modal>
            );
        }
    }
);

export default class MAMCACriteria extends Component {
    constructor(props) {
        super(props);
        const panes = [
            { title: 'Tab 1', key: '1' },
        ];
        this.state = {
            activeKey: Cookie.get('activeKey'),
            email: Cookie.get("email"),
            MCACriteria: [],
            MCACriteriaGroup: [],
            MCAid: "",
            createVisible: false, //for create modal
            editVisible: false, //for edit modal,
            loading: true, //the loading status default true
            eCriteria: {}, //for edited criterion
            activeKey: '1',
            panes,
            projectActors: []
        };
    }


    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/alternative/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 1) {
            this.props.history.push(`/mamcaactors/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 3) {
            this.props.history.push(`/mamcaweight/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 4) {
            this.props.history.push(`/mamcaevaluation/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 5) {
            this.props.history.push(`/mamcaresult/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
    }

    onChange = (activeKey) => {
        this.setState({ activeKey });
        Cookie.set('activeKey', activeKey);
        const result = [{ criteriaGroup: [...new Set([].concat(...this.state.projectActors[activeKey - 1].actorCriteria.map(o => o.criteriaName)))] }]; //magic function for save unique criteria group in one list                   
        this.formRef.props.form.resetFields(); //reset the form
        this.EformRef.props.form.resetFields(); //reset the form
        this.setState({
            activeKey,
            MCACriteria: this.state.projectActors[activeKey - 1].actorCriteria,
            MCAid: this.state.projectActors[activeKey - 1]._id,
            MCACriteriaGroup: result[0].criteriaGroup,
        });
    }

    //show or cancel create modal
    showCreateModal = () => {
        this.setState({ createVisible: true });
    }

    handleCreateCancel = () => {
        this.setState({ createVisible: false });
    }

    //show or cancel edit modal
    showEditModal = () => {
        this.setState({ editVisible: true });
    }

    handleEditCancel = () => {
        this.setState({ editVisible: false });
    }

    //create alternative
    handleCreate = () => {
        const form = this.formRef.props.form; //get all the data from modal

        form.validateFields((err, values) => { //can get values based on name 
            let criteriaIndicator = values.criteriaIndicator
            if (values.criteriaIndicator) { //trim the project name to check the length
                criteriaIndicator = values.criteriaIndicator.trim()
            }
            if (err || values.criteriaName.trim().length === 0) { //trim the project name to check the length
                return;
            }
            else {
                fetch('/project/createMAMCACriteria', { //REST create alternative
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actid: this.state.MCAid, //get the id of alternative
                        criteriaName: values.criteriaName.trim(),
                        criteriaDescription: values.criteriaDescription,
                        criteriaIndicator: criteriaIndicator,
                        criteriaGroup: values.criteriaGroup
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectActors();
                            message.success(json.message); //create successfully, show message
                            this.setState({ createVisible: false }); //make modal invisible
                            form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });

            }
        });
    }

    //edit alterntive
    handleEdit = () => {
        const form = this.EformRef.props.form; //get data from modal
        var pid = "0"
        if (this.EformRef.props.eCriteria.cid) {
            pid = this.EformRef.props.eCriteria.cid
        }
        form.validateFields((err, values) => { //can get values based on name
            let criteriaIndicator = values.criteriaIndicator
            if (values.criteriaIndicator) { //trim the project name to check the length
                criteriaIndicator = values.criteriaIndicator.trim()
            }
            if (err || values.criteriaName.trim().length === 0) { //trim the project name to check the length
                return;
            }
            else {
                if (values.criteriaName.trim() === this.EformRef.props.eCriteria.criteriaName && values.criteriaIndicator === this.EformRef.props.eCriteria.criteriaIndicator && this.EformRef.props.eCriteria.criteriaDescription === values.criteriaDescription) { //no change
                    this.setState({ editVisible: false }); //make modal invisible
                    form.resetFields(); //reset the form
                }
                else {
                    let nameNotChanged = false
                    if (values.criteriaName.trim() === this.EformRef.props.eCriteria.criteriaName && values.criteriaIndicator !== this.EformRef.props.eCriteria.criteriaIndicator && this.EformRef.props.eCriteria.criteriaDescription === values.criteriaDescription) {
                        nameNotChanged = true
                    }
                    if (values.criteriaName.trim() === this.EformRef.props.eCriteria.criteriaName && values.criteriaIndicator === this.EformRef.props.eCriteria.criteriaIndicator && this.EformRef.props.eCriteria.criteriaDescription !== values.criteriaDescription) {
                        nameNotChanged = true
                    }
                    if (values.criteriaName.trim() === this.EformRef.props.eCriteria.criteriaName && values.criteriaIndicator !== this.EformRef.props.eCriteria.criteriaIndicator && this.EformRef.props.eCriteria.criteriaDescription !== values.criteriaDescription) {
                        nameNotChanged = true
                    }
                    fetch('/project/editMAMCACriteria', { //REST edit project
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            uid: this.props.match.params.projectid,
                            actid: this.state.MCAid, //get the id of alternative
                            pid: pid, //parent criterion id
                            cid: this.EformRef.props.eCriteria._id,
                            criteriaName: values.criteriaName.trim(),
                            criteriaIndicator: criteriaIndicator,
                            criteriaDescription: values.criteriaDescription,
                            nameNotChanged: nameNotChanged,
                        }),
                    }).then(res => res.json())
                        .then(json => {
                            if (json.success) {
                                this.getProjectActors();
                                message.success(json.message); //create successfully, show message
                                this.setState({ editVisible: false }); //make modal invisible
                                form.resetFields(); //reset the form
                            }
                            else {
                                message.error(json.message); //create unsuccessful, show alert
                            }
                        });
                }
            }
        });
    }


    //get the actors and criteria
    getProjectActors = () => {
        fetch(`/project/getProjectActors/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) { //set tabs
                    if (json.MAMCAActorGroups && json.MAMCAActorGroups.length !== 0) {
                        let panes = []
                        let index = 1
                        json.MAMCAActorGroups.forEach(obj => {
                            panes.push({ title: obj.actorGroupName, key: index, id: obj._id })
                            index++
                        })
                        const result = [{ criteriaGroup: [...new Set([].concat(...json.MAMCAActorGroups[this.state.activeKey - 1].actorCriteria.map(o => o.criteriaName)))] }]; //magic function for save unique criteria group in one list                   
                        json.MAMCAActorGroups.forEach(aobj => { //all actors
                            aobj.actorCriteria.forEach(function (obj) { //change the structure of criteria make it can be listed as children
                                obj["children"] = obj.subCriteria
                                delete obj["subCriteria"];
                                obj.children.forEach(function (subobj) {
                                    subobj["criteriaName"] = subobj.subCriteriaName
                                    delete subobj["subCriteriaName"];
                                    subobj["criteriaDescription"] = subobj.subCriteriaDescription
                                    delete subobj["subCriteriaDescription"];
                                    subobj["criteriaIndicator"] = subobj.subCriteriaIndicator
                                    delete subobj["subCriteriaIndicator"];
                                    subobj["criteriaWeight"] = subobj.subCriteriaWeight
                                    delete subobj["subCriteriaWeight"];
                                    subobj["cid"] = obj._id
                                    subobj["pCiteriaName"] = obj.criteriaName
                                })
                                if (obj.children.length === 0) {
                                    delete obj["children"];
                                }
                            })
                        })
                        this.setState({
                            projectName: json.projectName,
                            projectType: json.projectType,
                            projectActors: json.MAMCAActorGroups,
                            MCACriteriaGroup: result[0].criteriaGroup,
                            MCACriteria: json.MAMCAActorGroups[this.state.activeKey - 1].actorCriteria,
                            panes: panes,
                            MCAid: json.MAMCAActorGroups[this.state.activeKey - 1]._id,
                            loading: false
                        }) //save project data
                    }
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }


    deleteMCACriteria(record) { //delete alternative
        var pid = "0"
        if (record.cid) {
            pid = record.cid
        }
        fetch('/project/deleteMAMCACriteria', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                actid: this.state.MCAid, //get the id of alternative
                pid: pid, //parent criterion id
                cid: record._id
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProjectActors(); //if success, refresh the criteria list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });
    }

// Export template or data from the page into Excel
downloadTemplate = () => {
    // Use the current table data from state
    const { MCACriteria } = this.state;

    // Check if there is existing data on the page
    let existingData = MCACriteria && MCACriteria.length > 0 ? MCACriteria : null;

    let data = [];

    // If there is existing data, map it to the Excel format
    if (existingData) {
        existingData.forEach(mainItem => {
            // Add main criterion
            data.push({
                criteriaName: mainItem.criteriaName || '',
                mainCriteria: '/',  // This is a main criterion
                criteriaDescription: mainItem.criteriaDescription || '',
                criteriaIndicator: mainItem.criteriaIndicator || ''
            });

            // If the main criterion has subcriteria, add them as well
            if (mainItem.children && mainItem.children.length > 0) {
                mainItem.children.forEach(subItem => {
                    data.push({
                        criteriaName: subItem.criteriaName || '',
                        mainCriteria: mainItem.criteriaName,  // Link subcriterion to its main criterion
                        criteriaDescription: subItem.criteriaDescription || '',
                        criteriaIndicator: subItem.criteriaIndicator || ''
                    });
                });
            }
        });
    } else {
        // If no data, provide a default template
        data = [
            { criteriaName: 'C_1', mainCriteria: '/', criteriaDescription: 'Some description for C_1', criteriaIndicator: 'The indicator for C_1' },
            { criteriaName: 'C_2', mainCriteria: '/', criteriaDescription: 'Some description for C_2', criteriaIndicator: 'The indicator for C_2' },
            { criteriaName: 'C_11', mainCriteria: 'C_1', criteriaDescription: 'Some description for C_11', criteriaIndicator: 'The indicator for C_11' }
        ];
    }

    // Define Excel headers
    let headers = [
        { header: 'Criterion Name', key: 'criteriaName' },
        { header: 'It is a criterion under which criterion?', key: 'mainCriteria' },
        { header: 'Criterion Description', key: 'criteriaDescription' },
        { header: 'Criterion Indicator', key: 'criteriaIndicator' }
    ];

    // Prepare the Excel file
    let fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let fileExtension = '.xlsx';

    // Convert data to a sheet
    let ws = XLSX.utils.json_to_sheet(data);
    let ws_with_headers = XLSX.utils.sheet_add_aoa(ws, [headers.map(h => h.header)], { origin: 'A1' });

    // Create workbook
    let wb = { Sheets: { data: ws_with_headers }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Save the file
    let dataBlob = new Blob([excelBuffer], { type: fileType });
    saveAs(dataBlob, `Criteria_data${fileExtension}`);
};





 // Upload Excel file
uploadExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: 'binary' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet);

        if (data && data.length > 0) {
            // Confirm with the user
            if (window.confirm("Do you want to upload the criteria? You will lose all previous evaluation results.")) {
                // Format data for backend
                fetch('/project/createExcelCriteria', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actid: this.state.MCAid,  // Actor group ID
                        ExcelCriteria: data  // The criteria from Excel
                    })
                }).then(res => res.json())
                  .then(json => {
                      if (json.success) {
                          window.location.reload();  // Reload the page to reflect the changes
                      } else {
                          message.error(json.message);  // Display error message if upload failed
                      }
                  });
            }
        }
    };

    reader.readAsBinaryString(file);
    // Prevent default behavior
    return false;
};



    //save all the form data of create
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }
    //save all the form data of edit
    saveEFormRef = (formRef) => {
        this.EformRef = formRef;
    }

    checkDisable() {
        let disable = false
        this.state.projectActors.forEach(obj => {
            if (obj.actorCriteria.length < 1) {
                disable = true
            }
        })
        return disable
    }

    componentDidMount() {
        try {
            this.setState({ activeKey: Cookie.get('activeKey') })
            this.getProjectActors() //get actor group first
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mamcaSteps = [{
            title: 'Alternatives',
        },
        {
            title: 'Actors',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        const columns = [{ //the column title of the table
            title: 'Criteria Name', //the title of column
            dataIndex: 'criteriaName', //the data index can be used for searching, filtering
            key: 'criteriaName',
            sorter: (a, b) => { if (a.criteriaName > b.criteriaName) { return -1; } if (a.criteriaName < b.criteriaName) { return 1; } return 0; },
            render: (text, record) => <Popover content={record.criteriaDescription} title="Description"><span style={{ cursor: "pointer" }}>{text}</span></Popover>, //make it clickable to the project
            width: '40%',
        },
        { //the column title of the table
            title: 'Criteria Indicator', //the title of column
            dataIndex: 'criteriaIndicator', //the data index can be used for searching, filtering
            key: 'criteriaIndicator',
            width: '40%',
        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text, record) => (
                <span>
                    {/* save the edited alternative data, which will be used later in edit modal, and then show the edit modal */}
                    <Link to="#" onClick={() => { this.setState({ eCriteria: record }); this.showEditModal(); }}>Edit</Link>
                    <Divider type="vertical" />
                    {/* after comfirmation we can delete the alternative */}
                    <Popconfirm title="Are you sure you want to delete this criteria?" onConfirm={() => { this.deleteMCACriteria(record) }} okText="Yes" cancelText="No">
                        <Link to="#">Delete</Link>
                    </Popconfirm>

                </span>
            ),
        }];

        return <div className="MCACriteria">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                        <h3>{this.state.projectName}</h3>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={2} onChange={this.onStepChange}>
                    {mamcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                <Tabs
                    size={"large"}
                    onChange={this.onChange}
                    activeKey={this.state.activeKey}
                >
                    {this.state.panes.map(pane => <TabPane tab={<span><Icon type="team" />{pane.title}</span>} key={pane.key}></TabPane>)}
                </Tabs>
                <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showCreateModal}><b>{"\uFF0B\n"}</b> Create a new criterion</Button>
                <Divider />
                <Text>Or use excel to upload data:&nbsp;</Text>
                <Button style={{ marginLeft: "0" }} onClick={this.downloadTemplate} > Download data in Excel</Button>

                <Upload accept=".xlsx,.xls" customRequest={({ file }) => this.uploadExcel(file)}>
                    <Button style={{ marginLeft: 8 }} type="primary" > Upload your data in Excel format</Button>
                </Upload>
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.MCACriteria} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                {this.checkDisable() ? <p>You have to create criteria for all actors to continue</p> : <div />}
                <div className="steps-action">
                    {/* disabled={this.checkDisable()} */}
                    <Button size="large" type="primary" >
                        <Link to={`/mamcaweight/${this.props.match.params.projectid}`}>Next</Link></Button>
                    <Button size="large" style={{ marginLeft: 8 }}>
                        <Link to={`/mamcaactors/${this.props.match.params.projectid}`}>Previous</Link></Button>
                </div>
            </Spin>
            <CreateForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.createVisible}
                onCancel={this.handleCreateCancel}
                onCreate={this.handleCreate}
                criteriaGroup={this.state.MCACriteriaGroup} //send criteria group
            />
            <EditForm
                wrappedComponentRef={this.saveEFormRef}
                visible={this.state.editVisible}
                onCancel={this.handleEditCancel}
                onCreate={this.handleEdit}
                eCriteria={this.state.eCriteria} //send the edited criteria info to the modal
            />
        </div>;
    }
}